import React from 'react'
import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material'
import { WarningAmber } from '@mui/icons-material'

interface Props {
  openedState: boolean
  onClose: () => void
  amount?: number
  order?: string
  address?: string
}

export const SterilizationDepositPopup: React.FC<Props> = ({ openedState, onClose, amount, order, address }) => {
  return (
    <Dialog
      open={openedState}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
        },
      }}
    >
      {/* Header with a strong color and icon */}
      <Box
        sx={{
          backgroundColor: 'error.main',
          color: 'white',
          fontSize: '22px',
          fontWeight: 700,
          width: 'fit-content',
          padding: '8px',
          paddingRight: '32px',
          borderRadius: '11px',
          transform: 'rotate(-1deg)',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <WarningAmber sx={{ mr: 1, fontSize: 28 }} /> Attention
      </Box>

      {/* Content with improved readability */}
      <DialogContent sx={{ padding: { xs: 1, md: 3 } }}>
        {amount && order && address ? (
          <Typography
            variant="body1"
            sx={{
              fontSize: '16px',
              lineHeight: 1.6,
              textAlign: 'center',
              color: 'text.primary',
            }}
          >
            Dans le cadre de l&apos;adoption, la stérilisation sera à prévoir.
            <br />
            Dans ce cadre, pensez bien à adresser un chèque de caution de <strong>{amount} euros</strong> à l&apos;ordre
            de <strong>{order}</strong>, à l&apos;adresse : <strong>{address}</strong>.
            <br />
            <br />
            Ce n&apos;est qu&apos;à la réception de ce chèque que l&apos;adoption sera définitivement validée.
          </Typography>
        ) : (
          <Typography
            variant="body1"
            sx={{
              fontSize: '16px',
              lineHeight: 1.6,
              textAlign: 'center',
              color: 'text.primary',
            }}
          >
            Dans le cadre de l’adoption, l’animal doit être stérilisé post adoption.
            <br />
            Un chèque de caution devra être adressé à l’association, merci de vous rapprocher de votre
            interlocuteur.trice pour en connaitre les détails.
            <br />
            <br />
            Ce n&apos;est qu&apos;à la réception de ce chèque que l&apos;adoption sera définitivement validée.
          </Typography>
        )}
      </DialogContent>

      {/* Prominent confirmation button */}
      <DialogActions sx={{ padding: 2 }}>
        <Button
          variant="contained"
          onClick={onClose}
          fullWidth
          size="large"
          sx={{
            textTransform: 'none',
            fontWeight: 'bold',
            borderRadius: 2,
            paddingY: 1.5,
          }}
        >
          C&apos;est fait
        </Button>
      </DialogActions>
    </Dialog>
  )
}
